import { Component } from '@angular/core';

@Component({
  selector: 'app-data-empty',
  templateUrl: './data-empty.component.html'
})
export class DataEmptyComponent {

}
